import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Slide,
  Typography,
} from '@mui/material';
import { Trans } from 'react-i18next';

import type { TableRowSelectionToastProps } from './TableRowSelectionToast.model';
import useStyles from './TableRowSelectionToast.styles';

const SLIDE_IN_OUT_TIMEOUT = 500;

const TableRowSelectionToast = ({
  isRowSelectionAnimated,
  testId,
  labelKey,
  totalCount,
  // Accepts an array of button objects
  buttons,
}: TableRowSelectionToastProps): JSX.Element => {
  const { classes } = useStyles();
  return (
    <Slide
      className={classes.toastWrapper}
      direction="up"
      in={isRowSelectionAnimated}
      timeout={{ enter: SLIDE_IN_OUT_TIMEOUT, exit: SLIDE_IN_OUT_TIMEOUT }}
      data-testid={testId}
    >
      <Accordion defaultExpanded>
        <AccordionSummary className="accordionSummary">
          <Box
            component="span"
            ml={1}
            data-testid={`${testId}-toast-accordion-summary`}
          >
            <Trans
              i18nKey={labelKey}
              values={{
                count: totalCount,
              }}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails data-testid={`${testId}-toast-accordion-details`}>
          {/* Loop through all the children and render them */}
          {buttons.map((button, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: buttons have no required unique field (testId is optional, labels may repeat) and render statelessly in a fixed order
            <Box key={index}>
              <Box
                onClick={button.action}
                role="button"
                tabIndex={0}
                className={`accordionDetails ${button.variant ? button.variant : 'primary'}`}
                data-testid={button.testId}
              >
                <Typography variant="small_body_medium">
                  {button.label}
                </Typography>
              </Box>

              <Divider orientation="horizontal" sx={{ width: '100%' }} />
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    </Slide>
  );
};
export default TableRowSelectionToast;
